import { createMiddleware } from '@shared/redux';
import { getDraftCampaign } from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.state';
import { showErrorToast } from '@shared/toasts';
import {
    HANDLE_SUBMIT_AD,
    HANDLE_DELETE_AD,
    CREATE_OR_UPDATE_AD_REQUEST_FAILED,
    DELETE_AD_REQUEST_SUCCEEDED,
    DELETE_AD_REQUEST_FAILED,
    deleteAd,
    deleteAdRequest,
    createMobeesAd,
    updateMobeesAd,
    getAds,
} from './ad.state';
import { formatDataForAd } from './ad.utils';

export const adMiddleware = createMiddleware({
    [HANDLE_SUBMIT_AD]: (state, action) => {
        const referenceId = action.payload.id;
        const Ad = getAds(state).find(ad => ad.id === referenceId);
        const campaignId = getDraftCampaign(state).id;
        const data = formatDataForAd(campaignId, { ...Ad, referenceId });

        if (Ad.remoteId) {
            return updateMobeesAd({
                remoteId: Ad.remoteId,
                referenceId,
                data,
            });
        }

        return createMobeesAd({ data, referenceId });
    },
    [HANDLE_DELETE_AD]: (state, action) => {
        const referenceId = action.payload.id;
        const Ad = getAds(state).find(ad => ad.id === referenceId);

        if (Ad.remoteId) {
            return deleteAdRequest({
                referenceId,
                remoteId: Ad.remoteId,
            });
        }

        return deleteAd(referenceId);
    },
    [CREATE_OR_UPDATE_AD_REQUEST_FAILED]: () => [
        showErrorToast({
            message: 'There was an error creating your Ad. Try again in a few minutes.',
        }),
    ],
    [DELETE_AD_REQUEST_SUCCEEDED]: (_, action) => [deleteAd(action.requestAction.referenceId)],
    [DELETE_AD_REQUEST_FAILED]: () => [
        showErrorToast({
            message: 'There was an error deleting your Ad. Try again in a few minutes.',
        }),
    ],
});
